define('fukit/view/app.a11y.announcements.view',['require','exports','module','../config','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var config = require('../config'),
      UIKit  = require('uikit/uikit');

  var AppA11yAnnouncementView = UIKit.ItemView.extend({
    className: 'accessiblity-text',

    template: function() {
      return '<ui name="announcementsView" />';
    },

    internalViewOptions: {
      announcementsView: {
        type: UIKit.Text.extend({ tagName: 'div' }),
      },
    },

    announce: function(announcement, ariaLive) {
      //if the aria-live manners have not been defined, default to 'polite'
      ariaLive = ariaLive || 'polite';

      //Update the aria-live attribute on the announcmentsView, and give the it a tabindex of 0
      //so it can receive focus.
      //NOTE: Focus seems to be necessary to make assistive technologies "notice" the aria-live region
      //has been updated.
      this.announcementsView.updateElementAttributes({ 'aria-live': ariaLive, tabindex: 0 });
      this.announcementsView.el.focus({ preventScroll: true });
      this.announcementsView.text = announcement;

      //Give the message time to be read, then reset the aria-live region its initial state
      setTimeout(this.resetAnnouncement.bind(this), config.get('a11y.announcement.timeout'));
    },

    resetAnnouncement: function() {
      this.announcementsView.removeElementAttribute('aria-live');
      this.announcementsView.removeElementAttribute('tabindex');
      this.announcementsView.text = '';
    },
  });

  module.exports = AppA11yAnnouncementView;
});

